export default __webpack_public_path__ + "static/media/servicios.3963e2d7.jpg";